export const RoutePaths = {
  auth: 'auth/*',
  dashboard: '/dashboard',
  'dashboard-v2': '/dashboard-v2',
  'dashboard-pro': '/dashboard-pro',
  inbox: '/inbox',
  inboxV3: '/inbox-v3',
  menu: '/menu-test',

  // report and analytic
  reportAnalyticInsight: '/report-analytics/insight',
  reportAnalyticActivityLogs: '/report-analytics/activity-logs',
  reportAnalyticBulkMessages: '/report-analytics/bulk-messages',
  reportAnalyticQuickMessages: '/report-analytics/quick-messages',
  reportAnalyticEmailToSmsMessages: '/report-analytics/email-to-sms-messages',
  reportAnalyticShortLink: '/report-analytics/short-link',
  reportAnalyticLandingPage: '/report-analytics/landing-page',
  reportAnalyticQuickApiMessages: '/report-analytics/api-messages',
  reportAnalyticFileSchedulerMessage: '/report-analytics/scheduler-messages',
  reportAnalyticFlow: '/report-analytics/flow',
  reportAnalyticFlowReport: '/report-analytics/flow/report/:id',

  emailToSms: '/email-to-sms',
  automation: '/automation',
  automationNew: '/automation/new',
  automationFlowDetail: '/automation/flow/:id',
  automationFlow: '/automation/:id',
  automationLogs: '/automation/logs',
  automationLogsDetail: '/automation/contacts-in-flows/event-logs/:id',
  automationFlowInstance: '/automation/contacts-in-flows/:id',

  templateAutomationNew: '/templates/automation/new',
  templateAutomationFlowDetail: '/templates/automation/flow/:id',

  senderId: '/sender-id',
  videoTutariols: '/video-tutariols',
  knowledgeBase: '/knowledge-base',
  newMessage: '/new-message/*',
  customOptOut: '/custom-optout',
  draft: '/draft',
  landingPage: '/landing-page',

  api: '/api',
  supportTicket: '/support-ticket',
  editCustomOpt: '/create',
  editListSegments: '/list-segments/client-list/edit-client',
  viewClientList: '/list-segments/client-list/view-client',
  createClient: '/list-segments/client-list/create-client-list',
  templateScratch: '/saved_campaigns/create-scratch',
  ourTemplates: '/template/our-template',
  newMessageStared: '/new-message/getting-started',
  // newMessage
  listSegments: '/list-segments/*',
  accounts: '/accounts/*',
  // integration app
  integration: '/integration',
  integrationDetail: '/integration/:id',
  // sub account
  subAccountUser: '/subAccount/user',
  subAccountUserDetail: '/subAccount/user/:id/*',
  // contact
  contactsAll: '/contacts/subscriber',
  contactsForm: '/tools/form',
  contactsTag: '/contacts/tags',
  contactsSegments: '/contacts/segments',
  contactsUnsubscribe: '/contacts/unsubscribe',
  contactsList: '/contacts/list',
  contactsListDetail: '/contacts/list/:id',

  // promo action
  promoAction: '/promo-action',

  //Upload History
  contactsUploadHistory: '/contacts/upload-history',

  // File Scheduler
  fileScheduler: '/file-scheduler',
  fileSchedulerForm: '/file-scheduler/form',
  schedulerDetail: '/scheduler/detail/:id',

  // Help
  howToVideos: '/help/how-to-videos',
  howToVideoDetail: '/help/how-to-videos/:id',

  // B-Card
  bCardSubscription: '/wallet-card/subscription',
  bCardSubscriptionActivate: '/wallet-card/subscription/activate',

  // Invite link
  inviteLink: '/invite-link',

  // Flow
  flow: '/flow',
  flowNew: '/flow/new',
  flowList: '/flow/list',
  flowDetail: '/flow/:id',
  flowReport: '/report-analytics/flow',
}
